import { EllipsedText, MaterialIcon, MaterialIconName } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { Asset, AssetMinimal } from '../../../types/asset';
import StyledTooltip from '../../ui/StyledTooltip';

function AssetItem({
  data,
  index,
  style,
}: Readonly<
  ListChildComponentProps<{
    assets: Array<AssetMinimal | Asset>;
    type: 'selectable' | 'deselectable';
    onClick: (asset: Asset | AssetMinimal) => void;
    isLoaded: (index: number) => boolean;
    tooltip?: string;
  }>
>) {
  const asset = data.assets[index];
  const iconName: { [key: string]: MaterialIconName } = {
    selectable: 'add',
    deselectable: 'remove',
  };
  const button = (
    <Button
      size="mini"
      shape="round"
      kind="tertiary"
      onClick={() => data.onClick(asset)}
    >
      <MaterialIcon
        name={iconName[data.type]}
        size="mini"
      />
    </Button>
  );

  const tooltipButton = <StyledTooltip content={data.tooltip || ''}>{button}</StyledTooltip>;

  return (
    <span style={style as CSSProperties}>
      <ListItem endEnhancer={() => (!!tooltipButton ? tooltipButton : button)}>
        <ListItemLabel description={asset?.assetType}>
          <EllipsedText inline>{asset?.label || '-'}</EllipsedText>
        </ListItemLabel>
      </ListItem>
    </span>
  );
}

export default memo(AssetItem);
